var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticStyle:{"display":"flex","flex-direction":"column"}},[_c('h1',{staticStyle:{"font-size":"18px","text-align":"left","margin":"2px 0px"},attrs:{"lan":"SensorSetting"}},[_vm._v("Sensor设置")]),_c('dpi-setting'),_c('common-report-rate',{staticStyle:{"margin-top":"20px"}}),_c('common-sensor')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }